<template>
  <div class="external" v-if="ready">
    <div>
      <fts-btn @click="continueWithGoogle">Continue with Google</fts-btn>
      <fts-btn @click="switchPage">Switch Page</fts-btn>
      <fts-btn @click="backPage">Switch to Dashboard</fts-btn>
    </div>

    <pre>
      {{ tempData }}
    </pre>

    <div style="margin-bottom: 2rem">
      <div class="web-frame">
        <div class="web-frame-header">
          <div class="web-frame-action-bar">
            <div class="web-frame-action"></div>
            <div class="web-frame-action"></div>
            <div class="web-frame-action"></div>
          </div>
        </div>
        <iframe
          width="1440"
          height="768"
          frameborder="0"
          :src="webUrl"
        ></iframe>
      </div>
    </div>

    <div class="mobile-frame">
      <iframe
        width="393"
        height="800"
        frameborder="0"
        :src="mobileUrl"
        class="mobile-frame-content"
      ></iframe>
      <img
        src="../../assets/images/design/iphone14-frame.png"
        alt=""
        class="mobile-frame-border"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import googleOAuth from "../commons/googleOAuth";

import FTSBtn from "../elements/FTSBtn";
import webAppConfig from "../commons/webApp.config";
import { authorizationStore } from "../store/authorizationStore";

const requestConfig = {
  baseURL: webAppConfig.baseURL,
};

export default {
  components: {
    "fts-btn": FTSBtn,
  },
  data: () => ({
    ready: false,
    webUrl: "https://app.inistate.com",
    mobileUrl: "https://m.inistate.com",
    tempData: {},
  }),
  methods: {
    switchPage() {
      this.webUrl = "https://app.inistate.com/#/list/GRb4QJVdBL?l=3YXDDBqQ1Aq8";
    },
    backPage() {
      this.webUrl = "https://app.inistate.com";
      this.mobileUrl = "https://m.inistate.com";
    },
    async continueWithGoogle() {
      try {
        googleOAuth.initCodeClient({
          client_id:
            "664109851190-3ttfk39akgebtpo5rhmrdflt3nehuiie.apps.googleusercontent.com",
          scope:
            "https://www.googleapis.com/auth/userinfo.email  https://www.googleapis.com/auth/userinfo.profile  https://www.googleapis.com/auth/spreadsheets",
        });
        const authCode = await googleOAuth.requestCode();
        this.$set(this.tempData, "googleOAuthCode", authCode);
        const res = await axios.post(
          "/api/connect/googlespreadsheet",
          {
            authCode: authCode,
          },
          {
            ...requestConfig,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(localStorage["ls.authorizationData"])[
                  "access_token"
                ],
            },
          }
        );
        if (res.data.authCode) {
          this.$set(this.tempData, "externalLoginAuthCode", res.data.authCode);
          const res2 = await axios.post(
            "/token",
            `grant_type=refresh_token&refresh_token=${res.data.authCode}`,
            {
              ...requestConfig,
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
        }
      } catch (err) {
        this.$toasted.global.error(err);
      }
    },
  },
  mounted() {
    if (authorizationStore.getters.isInternal) {
      googleOAuth.initCodeClient({
        client_id:
          "664109851190-3ttfk39akgebtpo5rhmrdflt3nehuiie.apps.googleusercontent.com",
        scope:
          "https://www.googleapis.com/auth/userinfo.email  https://www.googleapis.com/auth/userinfo.profile",
      });
      this.ready = true;
    } else {
      this.$router.replace({ name: "dashboard" });
    }
  },
};
</script>

<style lang="scss" scoped>
.external {
  padding: 1rem;
  .web-frame {
    display: inline-flex;
    flex-direction: column;
    border: 1px solid var(--fts-border);
    .web-frame-header {
      padding: 1rem;
      border-bottom: 1px solid var(--fts-border);
    }
    .web-frame-action-bar {
      display: flex;
    }
    .web-frame-action {
      height: 0.5rem;
      width: 0.5rem;
      border-radius: 10em;
      background-color: var(--fts-default);
      &:not(:first-child) {
        margin-left: 0.75rem;
      }
    }
  }
  .mobile-frame {
    position: relative;
    display: inline-flex;
    .mobile-frame-border {
      pointer-events: none;
      z-index: 1;
    }
    .mobile-frame-content {
      position: absolute;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>